import React from 'react'

const SyncButton = ({ onClick, disabled = false, isLoading = false, title = "Sync", label = "Sync", loadingLabel = "Syncing..." }) => {
	return (
		<button
			onClick={onClick}
			disabled={disabled || isLoading}
			className="inline-flex items-center px-3 py-2 text-sm font-medium text-emerald-700 bg-emerald-100 rounded-lg hover:bg-emerald-200 focus:ring-4 focus:outline-none focus:ring-emerald-300 disabled:opacity-50 disabled:cursor-not-allowed"
			title={title}
		>
			<svg className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
				<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
			</svg>
			<span className="ml-1">{isLoading ? loadingLabel : label}</span>
		</button>
	)
}

export default SyncButton
